// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FunelogPrivacyPolicy from './pages/FunelogPrivacyPolicy';
import Shukkin from './pages/Shukkin';
import ScrollToTop from './components/ScrollToTop'; // Import ScrollToTop component


function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add ScrollToTop here */}
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />  {/* Main content on home path */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Privacy Policy page */}
          <Route path="/shukkin" element={<Shukkin />} /> {/* Shukkin project page */}
          <Route path="/privacy/funelog" element={<FunelogPrivacyPolicy />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
